<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT  © {{ new Date().getFullYear() }}
      <b-link
        class="ml-25"
        href="https://www.ipsos.com/tr-tr"
        target="_blank"
      >Ipsos</b-link>
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>
    <!-- version -->
    <span class="float-md-right d-none d-md-block">
      <span>
        <small>v1.0.86</small> <faq-link
          :link-mode="true"
          style="display: inline;"
        />
      </span>
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'
import FaqLink from '@/layouts/components/FaqLink.vue'

export default {
  components: {
    BLink,
    FaqLink,
  },
}
</script>
